export const partners = {
  seo: {
    title: "Partneri együttműködés - Bespire",
    description: "Csatlakozz partnereink közé és segítsd az alkotókat sikereik elérésében. Dedikált eszközök, láthatóság és prémium támogatás várt rád.",
    keywords: "partner program, alkotói platform, együttműködés, technológiai partner, creator economy"
  },
  navigation: {
    benefits: "Előnyök",
    requirements: "Követelmények", 
    process: "Folyamat",
    contact: "Kapcsolat",
    home: "Főoldal"
  },
  hero: {
    badge: "Partneri program",
    title: "Csatlakozz a Bespire partnerek közé",
    subtitle: "Támogasd az alkotói gazdaságot és építsd velünk a jövőt",
    description: "Legyél része annak a küldetésnek, hogy minden alkotó sikeressé válhasson. Partnereink exkluzív előnyöket kapnak és kulcsszerepet játszanak a platform fejlődésében.",
    cta: "Jelentkezés partnernek"
  },
  benefits: {
    title: "Miért legyél a partnerünk?",
    subtitle: "Számtalan előnnyel járó partnerség vár rád",
    items: [
      {
        title: "Megjelenés a weboldalunkon",
        description: "Partnereink neve és logója megjelenik a főoldalunkon, növelve a márka láthatóságát.",
        icon: "Globe"
      },
      {
        title: "Partner badge használata",
        description: "Használhatod a 'Bespire Partner' badge-et a saját weboldalaidon és marketing anyagaidban.",
        icon: "Shield"
      },
      {
        title: "Dedikált admin felület",
        description: "Könnyedén kezelhetsz több creatort egyszerre a partnereknek kialakított adminisztrációs felületen.",
        icon: "Users"
      },
      {
        title: "Prioritás a támogatásban",
        description: "Partnereink elsőbbséget élveznek az ügyfélszolgálatnál és technikai támogatásnál.",
        icon: "Heart"
      },
      {
        title: "Korai hozzáférés új funkciókhoz",
        description: "Elsőként próbálhatod ki az új funkciókat és szolgáltatásokat még a nyilvános megjelenés előtt.",
        icon: "Zap"
      },
      {
        title: "Közös marketing lehetőségek",
        description: "Együtt dolgozunk a közös marketing kampányokon és rendezvényeken való megjelésen.",
        icon: "TrendingUp"
      },
      {
        title: "Hálózatépítési lehetőségek",
        description: "Kapcsolódj más partnerekhez és alkotókhoz exkluzív rendezvényeinken és közösségünkben.",
        icon: "MapPin"
      },
      {
        title: "Keresztértékesítési lehetőségek",
        description: "Értékesítheted saját szolgáltatásaidat a Bespire-től érkező ügyfeleknek és kiegészítő bevételi forrásokat hozhatsz létre.",
        icon: "Laptop"
      },
      {
        title: "Szolgáltatási díj felszámítása",
        description: "Számíts fel díjat a creatoroknak a weboldaluk elkészítéséért és személyre szabásáért.",
        icon: "DollarSign"
      }
    ]
  },
  partnerValue: {
    title: "Mit nyújtunk partnerként a creatoroknak?",
    subtitle: "A partnereinken keresztül a creatorok exkluzív extra szolgáltatásokat kapnak",
    description: "Partnereink nemcsak a saját szakértelmüket és szolgáltatásaikat kínálják, hanem hozzáférést biztosítanak a Bespire legfejlettebb technológiáihoz és exkluzív funkcióihoz is.",
    items: [
      {
        title: "Legfejlettebb AI technológia",
        description: "Partnereink használhatják a legújabb AI modelleket személyre szabott tartalom generáláshoz és automatizált üzleti folyamatokhoz.",
        icon: "Zap"
      },
      {
        title: "Exkluzív platform funkciók",
        description: "Korai hozzáférés az új fejlesztésekhez és béta verziójú funkciókhoz, amiket még a széles közönség nem használhat.",
        icon: "Users"
      },
      {
        title: "Kiemelt megjelenési lehetőségek",
        description: "Partnereink creatorjai előnyben részesülnek a platform promóciós felületein és kiemelt pozíciókban jelennek meg.",
        icon: "Shield"
      },
      {
        title: "Prémium sablonok és eszközök",
        description: "Hozzáférés exkluzív design sablonokhoz, fejlett analitikai eszközökhöz és prémium integrációkhoz.",
        icon: "Monitor"
      },
      {
        title: "Dedikált technikai támogatás",
        description: "24/7 technikai support és személyes ügyintéző a partneri projektek sikeréhez.",
        icon: "Heart"
      },
      {
        title: "API és egyedi integrációk",
        description: "Teljes API hozzáférés és egyedi integrációk fejlesztése a partner specifikus igények szerint.",
        icon: "Laptop"
      }
    ]
  },
  requirements: {
    title: "Kik lehetnek partnereink?",
    subtitle: "Keressük azokat a vállalatokat és szolgáltatókat, akik osztják az értékeinket",
    items: [
      {
        title: "Technológiai vállalatok",
        description: "Szoftver-, alkalmazás- és platformfejlesztők, akik kiegészítő szolgáltatásokat nyújtanak.",
        icon: "Monitor"
      },
      {
        title: "Marketing ügynökségek",
        description: "Digitális marketing és brand építési szakértők, akik segítik az alkotók növekedését.",
        icon: "TrendingUp"
      },
      {
        title: "Oktatási intézmények",
        description: "Egyetemek, főiskolák és képzési központok, akik alkotói kurzusokat kínálnak.",
        icon: "GraduationCap"
      },
      {
        title: "Pénzügyi szolgáltatók",
        description: "Bankok, fintech cégek és pénzügyi tanácsadók, akik támogatják az alkotói vállalkozásokat.",
        icon: "DollarSign"
      }
    ]
  },
  process: {
    title: "Hogyan működik a partnerség?",
    subtitle: "Egyszerű lépések a sikeres együttműködéshez",
    steps: [
      {
        title: "Jelentkezés",
        description: "Töltse ki a jelentkezési űrlapot és mutassa be cégét, valamint szolgáltatásait.",
        icon: "FileText"
      },
      {
        title: "Értékelés",
        description: "Csapatunk áttekinti a jelentkezését és 48 órán belül visszajelzést küld az eredményről.",
        icon: "CheckCircle"
      },
      {
        title: "Szerződés",
        description: "Sikeres értékelés esetén megkötjük a partneri megállapodást és megkezdődik az együttműködés.",
        icon: "FileCheck"
      },
      {
        title: "Onboarding",
        description: "Rendszerbevezetés és hozzáférések beállítása, hogy zökkenőmentesen kezdhessük meg a közös munkát.",
        icon: "Users"
      }
    ]
  },
  cta: {
    title: "Készen állsz a partneri együttműködésre?",
    subtitle: "Csatlakozz hozzánk és formáljuk együtt az alkotói gazdaság jövőjét!",
    button: "Jelentkezés most",
    note: "Nincs jutalék, nincs rejtett költség – csak kölcsönösen előnyös együttműködés."
  },
  contact: {
    title: "Kérdéseid vannak?",
    subtitle: "Vedd fel velünk a kapcsolatot!",
    email: "partners@bespire.com",
    responseTimeLabel: "Válaszidő",
    responseTime: "24 órán belül válaszolunk"
  },
  footer: {
    support: "Támogatás",
    getStarted: "Kezdjük el",
    contact: "Kapcsolat",
    privacy: "Adatvédelem",
    privacyComingSoon: "Adatvédelmi irányelvek hamarosan!"
  }
};